<template>
    <div class="tw-bg-blue-light filtres">
        <div class="limiter tw-flex tw-flex-col tw-items-start tw-gap-12">
            <div class="tw-w-full tw-items-center tw-grid md:tw-grid-cols-3 tw-gap-8 md:tw-gap-12">
                <span class="text-1-8 tw-uppercase tw-font-bold">Filtrer par <v-icon color="secondary" >mdi-pan-right</v-icon></span>
                <div class="tw-flex tw-justify-center tw-gap-8">

                        <v-btn
                                v-for="year in years" :key="year"
                                class="btn-shape"
                                :class="{'active' : year === yearSelected}"
                                color="primary"
                                @click="changeYear(year)"
                        >
                            Édition {{ year }}
                        </v-btn>

                </div>
                <div class="text-1-8 tw-uppercase tw-text-black tw-font-bold tw-justify-self-end">
                    {{ nbResults }} Résultats
                </div>
            </div>

            <div class="tw-w-full tw-grid tw-gap-8 md:tw-gap-12" :class="[yearSelected === new Date().getFullYear() ? 'md:tw-grid-cols-3' : 'md:tw-grid-cols-2']">
                <v-select
                        v-if="yearSelected === new Date().getFullYear()"
                        class="tw-shrink-0"
                        v-model="datesSelected"
                        :disabled="yearSelected !== new Date().getFullYear()"
                        :items="dates"
                        label="Date"
                        multiple
                        chips
                        @change="filtersChange"
                >
                    <template v-slot:selection="{ item, index }">
                        <v-chip color="white" v-if="index === 0">
                            <span>{{ item }}</span>
                        </v-chip>
                        <span
                                v-if="index === 1"
                                class="text-caption"
                        >
          (+{{ tagsSelected.length - 1 }} autres)
        </span>
                    </template>
                </v-select>
                <v-select
                        class="tw-shrink-0"
                        v-if="regionsItems"
                        v-model="regionsSelected"
                        :items="regionsItems"
                        label="Région"
                        multiple
                        chips
                        @change="filtersChange"
                >
                    <template v-slot:selection="{ item, index }">
                        <v-chip color="white" v-if="index === 0">
                            <span>{{ item.text }}</span>
                        </v-chip>
                        <span
                                v-if="index === 1"
                                class="text-caption"
                        >
          (+{{ regionsSelected.length - 1 }} autres)
        </span>
                    </template>
                </v-select>
                <v-select
                        class="tw-shrink-0"
                        v-if="types"
                        v-model="tagsSelected"
                        :items="types.nodes"
                        item-text="name"
                        item-value="termTaxonomyId"
                        label="Types d'événements"
                        multiple
                        chips
                        @change="filtersChange"
                >
                    <template v-slot:selection="{ item, index }">
                        <v-chip color="white" v-if="index === 0">
                            <span>{{ item.name }}</span>
                        </v-chip>
                        <span
                                v-if="index === 1"
                                class="text-caption"
                        >
          (+{{ tagsSelected.length - 1 }} autres)
        </span>
                    </template>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import filtresGql from "@/queries/Filtres.graphql"
export default {
    name: "Filtres",
    props : ['nbResults'],
    apollo: {
        regions : filtresGql,
        types : filtresGql
    },
    beforeMount() {
        this.filtersChange()
    },
    computed : {
        regionsItems() {
            if(!this.regions) return false
            let regionsItems = []



            for (let region of this.regions.nodes) {
                let itemHeader = {
                    header : region.name
                }
                regionsItems.push(itemHeader)
                if(region.termTaxonomyId === 6) {
                    const metropole = { text : 'Métropole' , "value" : 'metropole' , disabled : false}
                    regionsItems.push(metropole)
                }

                for (let regionSub of region.children.nodes) {
                    let item = { text : regionSub.name , "value" : regionSub.termTaxonomyId , disabled : false}
                    regionsItems.push(item)
                }
            }

            if(regionsItems.length === 0) {
                return false
            }
            return regionsItems
        },
        years() {
            const list = []

            const year = new Date().getFullYear();
            for (var i = year; i >= 2023; i--) {
                list.push(i);
            }

            return list
        }
    },
    data: () => ({

        dates: [
            '20.03.2024',
            '21.03.2024',
            '22.03.2024',
            '23.03.2024',
            '24.03.2024',
            '25.03.2024',
            '26.03.2024',
            '27.03.2024',
            '28.03.2024',
            '29.03.2024',
            '30.03.2024',
            '31.03.2024',
            '01.04.2024',
            '02.04.2024',
            '03.04.2024',
            '04.04.2024',
            '05.04.2024',
            '06.04.2024',
            '07.04.2024',
            '08.04.2024',
        ],
        yearSelected : new Date().getFullYear(),
        datesSelected: [],
        regionsSelected: [],
        tagsSelected: [],
    }),
    methods : {
        changeYear(year) {
            this.yearSelected = year
            this.datesSelected = []
            this.regionsSelected = []
            this.tagsSelected = []
            this.filtersChange()
        },
        filterForeignRegion(region) {
            this.datesSelected = []
            this.regionsSelected = [region]
            this.tagsSelected = []
            this.filtersChange()
        },
        filtersChange() {
            const filters = {
                year : this.yearSelected,
                dates : this.datesSelected,
                regions : this.regionsSelected,
                tags : this.tagsSelected
            }
            this.$emit('filter-change' , filters);
        }
    },
}
</script>

<style lang="scss" scoped>
.btn-shape {
  position: relative;
  color: $font-color !important;
  clip-path: polygon(10% 0, 100% 10%, 100% 90%, 0% 100%);
  &::before {
    content: '';
    display: block;
    width: calc(100% - 1rem);
    height: calc(100% - 1rem);
    top : 50%;
    left: 50%;
    background-color: #CFE7E2;
    transform: translate(-50% , -50%);
    clip-path: polygon(10% 0, 100% 10%, 100% 90%, 0% 100%);
    opacity: 1;
  }
  background-color: transparent !important;
  &.active {
    &::before {
      background-color: $primary;
    }
    color: #fff !important;
    background-color: $primary !important;
  }
}
.v-chip__content {
  color : rgba(0, 0, 0, 0.87) !important;
}

.limiter {
  margin-top : 3rem;
}
</style>